import { render, staticRenderFns } from "./BookRead.vue?vue&type=template&id=31ead95f&scoped=true&"
import script from "./BookRead.vue?vue&type=script&lang=js&"
export * from "./BookRead.vue?vue&type=script&lang=js&"
import style0 from "./BookRead.vue?vue&type=style&index=0&id=31ead95f&scoped=true&lang=css&"
import style1 from "./BookRead.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ead95f",
  null
  
)

export default component.exports